"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boothsQueryDtoSchema = void 0;
const zod_1 = require("zod");
exports.boothsQueryDtoSchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().positive().default(1).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(100).default(10).optional(),
});
